/** MyVPNBook 站点常量 */

export const SITE_ORIGIN = 'https://myvpnbook.com'



export const BRAND_NAME = 'MyVPNBook'



export const DOWNLOAD_PATH = '/get-free-vpn/'



export const APK_URL =

	process.env.VUE_APP_DEFAULT_APK ||

	'https://play.google.com/store/apps/details?id=com.secure.vpn.private.browser'



export const canonical = (path) => `${SITE_ORIGIN}${path}`



/**

 * 顶栏语言/地区切换：English 为首页，六国地区页 + 文档美国落地页。

 */

export const NAV_LANGUAGES = [

	{ code: 'en', label: 'English', short: 'EN', path: '/' },

	{ code: 'us', label: 'United States', short: 'US', path: '/locations/free-usa-vpn/' },

	{ code: 'es', label: 'Español', short: 'ES', path: '/locations/free-mexico-vpn/' },

	{ code: 'ru', label: 'Русский', short: 'RU', path: '/locations/free-russia-vpn/' },

	{ code: 'ko', label: '한국어', short: 'KO', path: '/locations/free-korea-vpn/' },

	{ code: 'hi', label: 'हिन्दी', short: 'HI', path: '/locations/free-india-vpn/' },

	{ code: 'ja', label: '日本語', short: 'JA', path: '/locations/free-japan-vpn/' },

]



/** 根据当前路径解析导航应高亮的语言 */

export function resolveNavLanguage(pathname) {

	const path = pathname || '/'

	const byLocation = NAV_LANGUAGES.find(

		(item) => item.path !== '/' && (path === item.path || path === item.path.replace(/\/$/, ''))

	)

	if (byLocation) return byLocation.code

	return 'en'

}
